<template>
  <div class="terms container my-5">
    <TermsContent />
  </div>
</template>

<script>
import TermsContent from '@/views/TermsContent.vue'

export default {
  name: 'TermsPrivacy',
  components: { TermsContent }
}
</script>